import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Colors } from 'src/core/themes/constants/colors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function TargetPill(props: any) {
  const { viewBox } = props;
  const x = 0;
  const y = viewBox.y - 6;
  const pillHeight = 24;
  const { isDarkMode } = useSiteTheme();

  return (
    <svg width="100%" height="100%">
      <rect
        x={viewBox.x}
        y={viewBox.y - pillHeight / 2}
        rx="12"
        ry="12"
        width="44"
        height={pillHeight}
        fill={isDarkMode ? Colors.neutral075 : Colors.neutral600}
      />
      <text
        x={viewBox.x + 21}
        y={viewBox.y}
        textAnchor="middle"
        dominantBaseline="middle"
        alignmentBaseline="middle"
        fill={vars.color.textPrimary}
        fontFamily="Arial, sans-serif"
        fontSize="10"
        fontWeight="500"
      >
        Target
      </text>
    </svg>
  );
}
